import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// import { getAnalytics } from "firebase/analytics";

// Firebase configuration
// You'll need to replace these with your actual Firebase config values
const firebaseConfig = {
  apiKey: "AIzaSyC557_KP5f8KG0oMtdL_5mvhDK3Iu7Kp6I",
  authDomain: "ratemyplate-43949.firebaseapp.com",
  projectId: "ratemyplate-43949",
  storageBucket: "ratemyplate-43949.firebasestorage.app",
  messagingSenderId: "7613492794",
  appId: "1:7613492794:web:ebb534a3c09c53ce398f03",
  measurementId: "G-2SNQGJMCD4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // Uncomment when needed

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
